import cn from 'classnames';
import { ComponentChild, ComponentChildren, JSX, Ref } from 'preact';

import { BaseButton } from '../BaseButton/BaseButton';

export type ButtonProps<T extends keyof JSX.IntrinsicElements = 'button'> = {
  component?: T;
  color?: 'primary' | 'secondary' | 'tertiary' | 'text' | 'accent' | 'video';
  size?: 'large' | 'medium' | 'small' | 'xsmall' | 'standard';
  startIcon?: ComponentChild;
  endIcon?: ComponentChild;
  buttonRef?: Ref<HTMLElement>;
  children?: ComponentChildren;
  className?: Exclude<
    JSX.IntrinsicElements[T]['className'],
    JSX.SignalLike<any>
  >;
} & Omit<JSX.IntrinsicElements[T], 'color' | 'size' | 'className'>;

export const Button = <T extends keyof JSX.IntrinsicElements = 'button'>({
  children,
  color = 'primary',
  startIcon,
  endIcon,
  size = 'large',
  className,
  ...props
}: ButtonProps<T>) => {
  return (
    <BaseButton
      className={cn(
        'vgp-button',
        `vgp-button-color-${color}`,
        `vgp-button-size-${size}`,
        {
          withIcon: startIcon || endIcon,
        },
        className
      )}
      {...props}
    >
      {startIcon && <span className="vgp-button-icon">{startIcon}</span>}
      {children}
      {endIcon && <span className="vgp-button-icon">{endIcon}</span>}
    </BaseButton>
  );
};
